import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import CICurrentForecastTracker from "./CICurrentForecastTracker";
import CIPastForecastTracker from "./CIPastForecastTracker";
import { setActiveDataElement } from "../../../redux/userSlice";



const CIDashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Concentrate Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection

              title="Concentrate Inventory Upload Dashboard"
            />
            <div className="container">
                {/* top table */}
            <CICurrentForecastTracker></CICurrentForecastTracker>
             {/* bottom table */}
           <CIPastForecastTracker></CIPastForecastTracker>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default CIDashboard;
